module.exports = __webpack_public_path__ + "img/start-validation.7712df68.png";